export const GET_ORDERS_BY_STATUS_FOR_A_CHEF = "GET_ORDERS_BY_STATUS_FOR_A_CHEF";
export const GET_COOKS_IN_THE_KITCHEN = "GET_COOKS_IN_THE_KITCHEN";
export const UPDATE_MODAL_COOKS = "UPDATE_MODAL_COOKS";
export const UPDATE_FORM_COOKS = "UPDATE_FORM_COOKS";
export const FORM_COOKS_CLEAN_UP = "FORM_COOKS_CLEAN_UP";